import { load } from '@iheartjane/utils';
import { Suspense } from 'react';

import { selectIdentification } from '@jane/monolith/customer/redux/identification';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
import { LoadingWrapper } from '@jane/shared/components';

import type { IdentificationProps } from './identification.types';

/** Code splitting to load convertIfPDF/pdfjs only when called */
const DeluxeIdentificationUploader = load(
  () => import('./idUploader'),
  'DeluxeIdentificationUploader'
);

export const IDIdentification = ({
  showValidationErrors,
  valid,
  onIdUploadAttempt,
  onRemove,
}: IdentificationProps) => {
  const { document, loading_government_photo } =
    useCustomerSelector(selectIdentification);

  if (!document) return null;

  return (
    <Suspense fallback={<LoadingWrapper isLoading />}>
      <DeluxeIdentificationUploader
        imageKey="government_photo"
        inputName="government-id"
        label="Upload Government ID"
        document={document}
        isLoading={loading_government_photo}
        valid={valid}
        showValidationErrors={showValidationErrors}
        onIdUploadAttempt={onIdUploadAttempt}
        onRemove={onRemove}
      />
    </Suspense>
  );
};
